import React, { useContext, useEffect, useState } from 'react';
import useRWD from '../../hooks/useRWD';
import { useNavigate } from 'react-router-dom';
import { Button, Form, Input, Checkbox, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import axios from 'axios';
import moment from 'moment';
//
import appConfigs from '../../configs';
import AuthContext from '../../contexts/authProvider';
import { GetEncryptedString, GetDecryptedString } from '../../utils/encryption';
import useLocalStorage from '../../hooks/useLocalStorage';
import { IsValidApiGatewayRsps } from '../../utils/valid';
import bg from '../../images/loginbg.jpg';
import bg_m from '../../images/loginbg_m.jpg';
import google_logo from '../../images/google_logo.svg';

const Login = ({ homePagePath }) => {
  const { user, AuthUser } = useContext(AuthContext);
  const [email, setEmail] = useLocalStorage('email', '');
  const [rememberAccount, setRememberAccount] = useLocalStorage('remember', 'false');
  const [loading, setLoading] = useState(false);
  const device = useRWD();
  const navigate = useNavigate();

  useEffect(() => {
    window.localStorage.removeItem('password');

    if (user) {
      navigate('/');
    }

    const handleMessage = (event) => {
      if (event.origin === window.location.origin) {
        const data = event.data;
        if (data.token) {
          AuthUser(data);
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [user, navigate, AuthUser]);

  const handleGoogleLogin = () => {
    axios
      .get(`${appConfigs.apiGatewayRfdmeURL}/auth/login`)
      .then((res) => {
        if (!IsValidApiGatewayRsps(res)) {
          console.log('login fail', res.data.msg);
          return;
        }

        const redirectUrl = res.data.data || '';
        if (redirectUrl) window.location.href = redirectUrl;
      })
      .catch((err) => {
        console.error('login error', err);
      });
  };

  const handleLogin = (values) => {
    const username = values.username.trim();
    const password = values.password.trim();
    if (!username || !password) {
      message.warning('請輸入帳號/密碼');
      return;
    }

    if (values.remember) {
      setEmail(GetEncryptedString(username));
      setRememberAccount(values.remember);
    } else {
      setEmail('');
      setRememberAccount('');
    }

    setLoading(true);
    axios
      .post(`${appConfigs.apiGatewayRfdmeURL}/auth/login`, {
        systemID: appConfigs.systemID,
        account: username,
        password: password,
      })
      .then((res) => {
        if (!IsValidApiGatewayRsps(res)) {
          message.error('登入失敗，請重新輸入帳號與密碼');
          console.warn('login fail', res);
          return;
        }

        if (!res.data.data.token) {
          message.error('登入失敗，無法取得授權金鑰');
          console.warn('login fail', res);
          return;
        }

        AuthUser({
          user: {
            email: username,
            userName: res.data.data.userName,
            menus: res.data.data.menuList || [],
            operations: res.data.data.operationList || [],
            otpID: res.data.data.otpID || '',
          },
          token: {
            access_token: res.data.data.token,
            token_type: 'bearer',
          },
          logoutPath: '/login',
        });

        navigate('/');
      })
      .catch((err) => {
        message.error('登入異常');
        console.error('login error', err);
      })
      .then(() => {
        setLoading(false);
      });
  };

  return (
    <div
      className="app-login"
      style={
        device !== 'hisesPC' && device !== 'PC'
          ? { backgroundImage: `url(${bg_m})` }
          : { backgroundImage: `url(${bg})` }
      }
    >
      <div className="app-login-content">
        <div className="container">
          <div className="app-login-form">
            <h1>微電ERP增強系統</h1>
            {process.env.REACT_APP_STAGE_NAME !== '正式區' && (
              <div className="stage-name">{process.env.REACT_APP_STAGE_NAME}</div>
            )}
            {(process.env.REACT_APP_STAGE_NAME || process.env.REACT_APP_STAGE_NAME !== '正式區') && (
              <Form
                name="login"
                layout="vertical"
                onFinish={handleLogin}
                initialValues={{
                  remember: rememberAccount,
                  username: GetDecryptedString(email),
                }}
                size="large"
                onFieldsChange={(changedFields) => {
                  if (changedFields[0].name[0] === 'remember') setRememberAccount((value) => !value);
                }}
              >
                <Form.Item
                  name="username"
                  rules={[{ required: true, message: 'Please input your Username!' }]}
                >
                  <Input
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder="Username"
                    autoComplete="username"
                  />
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your Password!',
                    },
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    type="password"
                    placeholder="Password"
                    autoComplete="current-password"
                  />
                </Form.Item>
                <Form.Item>
                  <Form.Item name="remember" valuePropName="checked" noStyle>
                    <Checkbox>記住帳號</Checkbox>
                  </Form.Item>
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit" loading={loading} block>
                    登入
                  </Button>
                </Form.Item>
              </Form>
            )}
            <Button
              onClick={handleGoogleLogin}
              icon={<img alt="google" width="14" height="14" src={google_logo} />}
              size="large"
              ghost
              block
            >
              用Google SSO登入
            </Button>
          </div>
        </div>
      </div>
      <div className="app-login-footer">
        <div className="container">
          <p>©{moment().year()} Micro Electricity Co., Ltd. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
